import React from "react";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import PopUpReturnProductSub from "./PopUpReturnProductSub";
import FullScreenDialog from '../PopUp/FullScreendialogs/FullScreen'
import { genURL } from "./../_getjson";
import axios from 'axios'
require("./../_css/PopUpOther.css");
/* const rowTable = 15; */
export default class PopUpReturnProduct extends React.Component {

  constructor(props) {
    super(props);
    this.P_DOCNO = React.createRef();
    this.Search = React.createRef();
    this.state = {
      SelSaleRef3Sub: false,
      col: [],
      rows: [],
      Htext: "",
      SHtype: 3,
      P_DOCNO: "",
      casschkbox: "far fa-square",
      casschkboxs: false,
      ckbox_length: 0,
      TAXRATE: 0,
      TAXTYPE: 0,
    };
  };
  chkdata = (data) => {
    var redata = "";
    if (data) {
      redata = data !== "" ? data : typeof data !== undefined ? data : "";
    }
    return redata;
  };
  //--------------------------------โชว์ PopUpARPaybillsub
  //รับค่าหน้า sub แล้วส่งค่ากลับหน้าหลัก
  Get_PopUpSelSaleRef3Sub = (data) => {
    if (data) {
      this.props.Get_SelSaleRef3(data, this.state.TAXTYPE, this.state.creditcode, this.state.DEPARTMENT, this.state.sitecode, this.state.salecode, this.state.DEBTAMOUNT, this.state.TAXRATE);
    }
    this.CloseDialog(false)
  };
  onClickRefresh = () => {
    this.componentDidMount();
  };
  Get_Data = () => {
    var dataArray = [];
    var Url = "CSVINVSALEREF/GetDOCNOS?TOP=100&ARCODE=" + this.props.ARCODE.trim() + "&DOCNOS=" + this.Search.current.value
    axios.get(genURL(Url)).then((res) => {
      if (res.data.length >= 1) {
        for (let i = 0; i < res.data.length; i++) {
          dataArray[i] = {
            number: i + 1,
            DOCNO: res.data[i].DOCNO,
            TAXNO: res.data[i].TAXNO,
            Col2: this.GetformatTimestamp(res.data[i].DOCDATE),
            Col3: this.GetformatTimestamp(res.data[i].DUEDATE),
            SALENAME: res.data[i].SALENAME,
            Col5: res.data[i].CREDITCODE,
            Col6: res.data[i].REMARK,
            ARNAME: res.data[i].ARNAME,
            CURRNAME: res.data[i].CURRNAME,
            SB: "0",
            DEPARTMENT: res.data[i].DEPARTMENT,
            DEBTAMOUNT: res.data[i].DEBTAMOUNT,
            TAXRATE: res.data[i].TAXRATE,
            TAXTYPE: res.data[i].TAXTYPE,
          };
        }
        this.setState({ col: dataArray });
        this.GetSearchTimeout();
      } else {
        dataArray = [];
        this.setState({ col: dataArray });
        this.GetSearchTimeout();
      }
    });
  };

  GetSearchTimeout = () => {
    this.setState({ rows: this.state.col });
  };
  GetformatTimestamp = (date) => {
    if (date) {
      var myDate = new Date(date);
      var newdate = myDate.getDate();
      if (myDate.getDate() < 10) {
        newdate = "0" + myDate.getDate();
      }
      var month = myDate.getMonth() + 1;
      if (myDate.getMonth() + 1 < 10) {
        month = "0" + (myDate.getMonth() + 1);
      }
      var year = myDate.getFullYear() + 543;
      return newdate + "/" + month + "/" + year;
    } else {
      return "";
    }
  };
  componentDidMount() {
    //โหลดหน้าครั้งแรกเรียก API โชว์ข้อมูล
    var dataArray = this.state.rows;
    console.log(this.props.type);
    switch (this.props.type) {
      case "SelSaleRef3":
        this.setState({ sh_Deposit: true });
        var Url = "CSVINVSALEREF/GetALL?TOP=100&ARCODE=" + this.props.ARCODE.trim()
        console.log(genURL(Url));
        axios.get(genURL(Url)).then((res) => {
          console.log(res.data);
          var j = 0;
          if (res.data.length >= 1) {
            for (let i = 0; i < res.data.length; i++) {
              dataArray[j] = {
                number: i + 1,
                DOCNO: res.data[i].DOCNO,
                TAXNO: res.data[i].TAXNO,
                Col2: this.GetformatTimestamp(res.data[i].DOCDATE),
                Col3: this.GetformatTimestamp(res.data[i].DUEDATE),
                SALENAME: res.data[i].SALENAME,
                Col5: res.data[i].CREDITCODE,
                Col6: res.data[i].REMARK,
                ARNAME: res.data[i].ARNAME,
                CURRNAME: res.data[i].CURRNAME,
                SB: "0",
                DEPARTMENT: res.data[i].DEPARTMENT,
                DEBTAMOUNT: res.data[i].DEBTAMOUNT,
                sitecode: res.data[i].SITECODE,
                salecode: res.data[i].SALECODE,
                TAXRATE: res.data[i].TAXRATE,
                TAXTYPE: res.data[i].TAXTYPE,
              };
              j++;
              // this.setState({ taxtype: res.data[i].TAXTYPE });
            }
            this.setState({ col: dataArray });
            this.GetSearchTimeout();
          } else {
            dataArray = [];
            this.setState({ col: dataArray });
            this.GetSearchTimeout();
          }
        });
        this.setState({ col: dataArray, Htext: "ค้นหาเอกสารอ้างอิงขาย" });
        break;
    }
  }
  cellcheckbok = (cell, row, enumObject, rowIndex) => {
    var btn = this.state.rows[rowIndex].SB;
    var btnShow;
    switch (btn) {
      case "0":
        btnShow = (
          <span>
            <i className="far fa-square " onClick={this.Update_Status.bind(null, rowIndex, "1")} > </i>
          </span>
        );
        break;
      case "1":
        btnShow = (
          <span>
            <i className="far fa-check-square" onClick={this.Update_Status.bind(null, rowIndex, "0")} ></i>
          </span>
        );
        break;
      default:
        btnShow = (
          <span><i className=""></i> </span>
        );
    }
    return <div>{btnShow}</div>;
  };
  //เปลี่ยนสถานะ checkbox
  Update_Status = (Row, Status) => {
    if (Status === "ALL") {
      if (this.state.casschkboxs === false) {
        //กด checkbox เลือกทั้งหมด
        this.setState({ casschkbox: "far fa-check-square" });
        this.setState({ casschkboxs: !this.state.casschkboxs });
        var dataArray = this.state.rows;
        for (var i = 0; i < this.state.rows.length && this.state.rows[i].DOCNO; i++) {
          dataArray[i].SB = "1";
        }
        this.setState({ row: dataArray });
      } else {
        //กด checkbox ไม่เลือก
        this.setState({ casschkbox: "far fa-square" });
        this.setState({ casschkboxs: !this.state.casschkboxs });
        var dataArray = this.state.rows;
        for (var i = 0; i < this.state.rows.length && this.state.rows[i].DOCNO; i++) {
          dataArray[i].SB = "0";
        }
        this.setState({ row: dataArray });
      }
    } else {
      //เปลี่ยนสถานะไม่มีการเลือกทั้งหมด (checkbox หัวตาราง) เมื่อมีการติ๊กรายการใดรายการหนึ่งออก
      if (Status === "0") {
        this.setState({ casschkbox: "far fa-square" });
        this.setState({ casschkboxs: false });
      }
      //เปลี่ยนสถานะ เลือก/ไม่เลือก (checkbox แต่ละแถว)
      var dataArray = this.state.rows;
      dataArray[Row].SB = Status;
      this.setState({ rows: dataArray });
      //เปลี่ยนสถานะเลือกทั้งหมด (checkbox หัวตาราง) เมื่อเลือกทุกรายการ
      var sb_length = 0;
      console.log(this.state.rows.length);
      for (var i = 0; i < this.state.rows.length && this.state.rows[i].DOCNO; i++) {
        if (this.state.rows[i].SB === "1") {
          sb_length = sb_length + 1;
        }
      }
      if (sb_length === this.state.rows.length) {
        this.setState({ casschkbox: "far fa-check-square" });
        this.setState({ casschkboxs: true });
      }
    }
  };
  onSelectRow = (data, col, id, cellValue) => {
    //ส่งกลับเมื่อมีการคลิกเลือกข้อมูล

    if (col > 1 && data.DOCNO) {
      var dataArray = this.state.rows;
      dataArray[id].SB = "1";
      this.setState({ rows: dataArray });
      var docno = "";
      var DEBTAMOUNT = 0
      for (var i = 0; i < this.state.rows.length; i++) {
        if (this.state.rows[i].SB === "1") {
          DEBTAMOUNT += Number(this.state.rows[i].DEBTAMOUNT)
          docno += "&DOCNO=" + this.state.rows[i].DOCNO;
          this.setState({ creditcode: this.state.rows[i].Col5 });
          this.setState({ DEPARTMENT: this.state.rows[i].DEPARTMENT });
          this.setState({ sitecode: this.state.rows[i].sitecode });
          this.setState({ salecode: this.state.rows[i].salecode });
          this.setState({ TAXRATE: this.state.rows[i].TAXRATE });
          this.setState({ TAXTYPE: this.state.rows[i].TAXTYPE });
        }
      }
      this.setState({ DEBTAMOUNT: DEBTAMOUNT });
      this.P_DOCNO.current.value = docno;
      setTimeout(() => {
        // this.setState({ PopUpTYpe5: data });
        // this.setState({ SelSaleRef3Sub: true });
        //ชื่อ
        this.setState({ typeFullScreenDialog: "CSVINVSALEREFSUB" })
        //open
        this.setState({ openFullScreenDialog: true })
        //title
        this.setState({ titleFullScreenDialog: "ค้นหาใบส่งของ/ใบกำกับภาษี-SellnvSaleRefSub" })
      }, 200);
    }
  };
  onSubmit = () => {
    var docno = "";
    var DEBTAMOUNT = 0
    for (var i = 0; i < this.state.rows.length && this.state.rows[i].DOCNO; i++) {
      if (this.state.rows[i].SB === "1") {
        DEBTAMOUNT += Number(this.state.rows[i].DEBTAMOUNT)
        docno += "&DOCNO=" + this.state.rows[i].DOCNO;
        this.setState({ creditcode: this.state.rows[i].Col5 });
        this.setState({ DEPARTMENT: this.state.rows[i].DEPARTMENT });
        this.setState({ sitecode: this.state.rows[i].sitecode });
        this.setState({ salecode: this.state.rows[i].salecode });
      }
    }
    this.setState({ DEBTAMOUNT: DEBTAMOUNT });
    this.P_DOCNO.current.value = docno;
    if (docno) {
      // this.setState({ SelSaleRef3Sub: true });
      //ชื่อ
      this.setState({ typeFullScreenDialog: "CSVINVSALEREFSUB" })
      //open
      this.setState({ openFullScreenDialog: true })
      //title
      this.setState({ titleFullScreenDialog: "ค้นหาใบส่งของ/ใบกำกับภาษี-SellnvSaleRefSub" })
    }
  };
  CloseDialog = (e) => {
    this.setState({ openFullScreenDialog: e })
  }
  render() {
    const type = this.state.typeFullScreenDialog
    return (
      <div className="popup" style={{ "z-index": "100" }}>

        <FullScreenDialog open={this.state.openFullScreenDialog} title={this.state.titleFullScreenDialog} closeDialog={e => this.CloseDialog(e)}>
          {type === "CSVINVSALEREFSUB" ? <PopUpReturnProductSub closePopup={e => this.CloseDialog(e)} Get_PopUpSelSaleRef3Sub={this.Get_PopUpSelSaleRef3Sub} Data={this.state.valuePopup5} ARCODE={this.props.ARCODE} P_DOCNO={this.P_DOCNO.current.value} from="PopUpSelSaleRef3" /> : null}
        </FullScreenDialog>


        <div className="popup_inner">
          {this.props.Data}
          <div className="PopUpOtherDivH" align="left">
            <div className="PopUpOtherDivH1">
              <i className="fas fa-search"> ค้นหาใบส่งของ/ใบกำกับภาษี-SellnvSaleRef</i>
            </div>
            <div className="PopUpOtherDivH2" onClick={this.props.closePopup}>
              <i className="fas fa-times"></i>
            </div>
          </div>
          <div className="panel-body divTable" align="left">
            <input type="hidden" className="form-control " ref={this.P_DOCNO} />
            <div className="input-group width-grop">
              <input type="text" className="form-control" placeholder="ค้นหาเลขที่เอกสาร" onKeyUp={(e) => { if (e.key === "Enter") { this.Get_Data() } }} ref={this.Search} />
              <span className="input-group-addon txt-img icon">
                <i className="fas fa-search" onClick={this.Get_Data.bind()}></i>
              </span>
              <span className="input-group-addon txt-img icon">
                <i className="fas fa-sync-alt" onClick={this.onClickRefresh}></i>
              </span>
            </div>


            <div style={{ marginTop: "10px" }} >
              <BootstrapTable
                data={this.state.rows}
                options={{ onRowClick: this.onSelectRow, noDataText: "ไม่พบข้อมูลที่ค้นหา", }}
                height="600"
                hover condensed /* search */>
                <TableHeaderColumn columnClassName="columnAll columnNumber" className="columnNumber" dataAlign="center" width="35" dataField="number" isKey /* dataFormat={this._chkload.bind(this)} */></TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="35" dataField="SB" dataAlign="center" editable={false} dataFormat={this.cellcheckbok.bind(this)}><div onClick={this.Update_Status.bind(null, "", "ALL")}>  <i style={{ fontSize: "20" }} className={this.state.casschkbox}></i></div></TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="180" dataField="DOCNO" dataSort={true}>เลขที่เอกสาร</TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="180" dataField="TAXNO" dataSort={true}>ใบกำกับภาษี</TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="80" dataField="Col2" dataSort={true}>วันที่เอกสาร</TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="80" dataField="Col3" dataSort={true}>ลงวันที่</TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="150" dataField="SALENAME">พนักงานขาย</TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="80" dataField="Col5">รหัสเครดิต</TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="80" dataField="Col6">หมายเหตุ</TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="150" dataField="ARNAME" >ลูกค้า</TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="80" dataField="CURRNAME">สกุลเงิน</TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="80" dataField="DEBTAMOUNT">จำนวนเงิน</TableHeaderColumn>
                <TableHeaderColumn dataField="sitecode" hidden></TableHeaderColumn>
                <TableHeaderColumn dataField="salecode" hidden></TableHeaderColumn>
                <TableHeaderColumn dataField="TAXRATE" hidden></TableHeaderColumn>
              </BootstrapTable>
            </div>
            <button className="PUSDbtn" style={{ float: 'right' }} onClick={this.onSubmit}>
              <i className="fas fa-check"> ตกลง </i>
            </button>
          </div>
        </div>
      </div >
    );
  }
}
